import React, { useEffect, useState } from 'react'
import { WithdrawalOpportunityListPresenter } from './withdrawals-opportunity-list-presenter'
import { useParams } from 'react-router-dom'
import { investorServices, withdrawalServices } from '../../services'
import { InvestorProps, WithdrawalSearchParamsV1, WithdrawRequest } from '../../lib/types'

const WithdrawalOpportunityListContainer = () => {
  const { investorId } = useParams()
  const [investorProfile, setInvestorProfile] = useState<InvestorProps>({} as InvestorProps)
  const [withdrawals, setWithdrawals] = useState<WithdrawRequest[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const [searchParams, setSearchParams] = useState<WithdrawalSearchParamsV1>({
    limit: '10',
    offset: '0',
    search: '',
    filter: '',
    sort: '',
    investor_id: investorId,
  })
  const [pagination, setPagination] = useState({
    total: 0,
    limit: 10,
    count: 5,
    offset: 0,
  })

  // Fetch investor information
  useEffect(() => {
    const getInvestorProfileDetails = async () => {
      const response = await investorServices.getInvestorProfile(Number(investorId))
      if (response) {
        setInvestorProfile(response)
      }
    }

    if (investorId) {
      getInvestorProfileDetails()
    }
  }, [investorId])

  // Fetch withdrawal request list
  useEffect(() => {
    const fetchAllWithdrawals = async () => {
      const data = await withdrawalServices.getWithdrawals(searchParams)
      if (data.status === 200) {
        setWithdrawals(data.withdrawals)
        setPagination(data.pagination)
      }
    }
    fetchAllWithdrawals()
  }, [currentPage, searchParams])

  const handleSearchParams = async ({ name, value }: { name: string; value: string }) => {
    const { limit } = pagination
    setSearchParams({
      ...searchParams,
      offset: '0',
      limit: limit.toString(),
      [name]: value,
    })
    setCurrentPage(1)
    setPagination({ ...pagination, offset: 0 })
  }

  const handleCurrentPage = (currentPage: number) => {
    const { limit } = pagination
    setCurrentPage(currentPage)
    setSearchParams({
      ...searchParams,
      offset: `${(currentPage - 1) * limit}`,
    })
    setPagination({ ...pagination, offset: (currentPage - 1) * limit })
  }

  const resetSearchParams = async () => {
    setSearchParams({
      limit: '10',
      offset: '0',
      search: '',
      filter: '',
      sort: '',
      investor_id: investorId,
    })
  }

  return (
    <WithdrawalOpportunityListPresenter
      investorProfile={investorProfile}
      searchParams={searchParams}
      withdrawals={withdrawals}
      currentPage={currentPage}
      pagination={pagination}
      handleSearchParams={handleSearchParams}
      handleCurrentPage={handleCurrentPage}
      resetSearchParams={resetSearchParams}
    />
  )
}

export { WithdrawalOpportunityListContainer }
